export default __webpack_public_path__ + "static/media/hotel-room.5c3ca4cb.png";